import { Arrow, ArrowSwap } from '@fs/zion-icon'
import { Button, IconButton, useOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DemotePromoteMembersDialogOverlay from './DemotePromoteMembersDialogOverlay'
import { showElement } from '../../../util/CssUtil'

export default function DemotePromoteMembersButton({ members, promoting, refreshData, show }) {
  const overlay = useOverlay()
  const { t } = useTranslation()

  return (
    <span css={show !== undefined && showElement(show)}>
      <DemotePromoteMembersDialogOverlay members={members} refreshData={refreshData} {...overlay} />
      {promoting === undefined ? (
        <Button
          id="Demote/Promote Group Members"
          Icon={ArrowSwap}
          iconDirection="down"
          emphasis="high"
          onClick={overlay.handleClick}
        >
          {`${t('action.demote', 'Demote')}/${t('action.promote', 'Promote')}`}
        </Button>
      ) : (
        <IconButton
          id={promoting ? 'Promote Group Member' : 'Demote Group Member'}
          Icon={Arrow}
          onClick={overlay.handleClick}
          iconDirection={promoting ? 'up' : 'down'}
          color={promoting ? 'green' : 'red'}
        />
      )}
    </span>
  )
}
